<template >
    <div class="detail" v-if="gdLoading == 'loaded'">
        <div class="detail_img">
            <img :src="goodsDetail.goodsIcon" alt="">
        </div>
        <p class="detail_name">{{goodsDetail.iapName}}</p>
        <p class="detail_content">{{goodsDetail.iapContent}}</p>
        <div class="line"></div>
        <p class="detail_price"> {{this.$t('total')}}: {{curGearInfo[goodsDetail.price] + currency}}</p>
        <p class="detail_type_tips">{{this.$t('payTypeSelect')}}</p>
        <template v-if="goodsDetail.currency">
            <van-button v-for="item of payModeInfo.paymentInfo[0].paymentList" size="large" @click="payHandle(item)">{{item.payModeName}}</van-button>
        </template>
    </div>
</template>
  
<script>
import {mapActions, mapGetters} from 'vuex';
import qs from 'qs';
import moment from 'moment'

export default {
  name: 'Detail',
  data($vm){
    return{
        active: '',
        currency: ''
    }
  },
  created(){
  },
  methods:{
    ...mapActions(['getThirdPayGoodsDetail', 'getAllPayMode', 'getCurrencyGear', 'createThirdPayOrder']),
    payHandle(item){
        let actCountry = this.payModeInfo.paymentInfo[0]
        let actType = item
        let payExtInfo = {
            ...JSON.parse(actType.payExtInfo),
            country: actCountry.countryCode,
            language: this.language,
            paymentDetail: JSON.parse(actType.payExtInfo)
        }
        this.createThirdPayOrder({
            payChannel: actType.payChannel,
            appId: this.appId,
            goodsLists: [this.goodsDetail],
            payExtInfo: payExtInfo,
            returnUrl: window.location.origin + '/finishdetail',
            // returnUrl: 'https://www.baidu.com',
            countryId: actCountry.countryId,
            payModeId: actType.payModeId,
            payCurrency: actType.currency,
            cpCurrency: this.goodsDetail.currency,
            accessToken: this.accessToken
        })
    }
  },
  computed:{
    ...mapGetters(['goodsDetail', 'gdLoading', 'payModeInfo', 'pmLoading', 'curGearInfo', 'cgLoading', 'orderData', 'orderStatus']),
  },
  mounted(){
    this.env = CONFIG.env
    this.accessToken = window.localStorage.getItem('accessToken')
    this.appId = window.localStorage.getItem('appId')
    this.language = window.localStorage.getItem('language')
    this.storage = localStorage.getItem('storage') ? JSON.parse(localStorage.getItem('storage')) : []
    // if(typeof(ntAndroidWeb) !== 'undefined'){
        this.getThirdPayGoodsDetail({
            appId: this.appId,
            language: this.language,
            accessToken: this.accessToken,
            goodsInfo: {
                iapId: typeof(ntAndroidWeb) !== 'undefined' && JSON.parse(ntAndroidWeb.getCpCustomParams()).iapId,
                // iapId: '90001',
                amount: 1
            }
        })
    // }
    this.getAllPayMode({
        appId: this.appId,
        language: this.language,
        accessToken: this.accessToken
    })
    this.$watch('cgLoading', val => {
        if(val == 'loaded'){
            
        }
    })
    this.$watch('pmLoading', val => {
        if(val === 'loaded'){
            let actCountry = this.payModeInfo.paymentInfo[0]
            let actType = actCountry.paymentList[0]
            this.currency = actType.currency
            this.payChannel = actType.payChannel
            this.getCurrencyGear({
                targetCurrency: actType.currency,
                appId: this.appId,
                accessToken: this.accessToken,
                payModeId: actType.payModeId,
            })
        }
    })
    this.$watch('gdLoading', val => {
        if(val === 'loaded'){

        }
    })
    this.$watch('orderStatus', val => {
        if(val == 'stated'){
            let actCountry = this.payModeInfo.paymentInfo[0]
            let actType = actCountry.paymentList[0]
            if(actType.payChannel == 'gash' || actType.payChannel == 'p99'){
                this.payLoadShow = true
                const tempForm = document.createElement("form")
                tempForm.action = this.orderData.extInfo.redirectUrl
                tempForm.target = '_self'
                tempForm.method = 'post'
                tempForm.style.display = 'none'
                let opt = document.createElement("input")
                opt.name = 'data'
                opt.value = this.orderData.extInfo.data
                tempForm.appendChild(opt)
                document.body.appendChild(tempForm)
                tempForm.submit()
            } else {
                window.location.href = this.orderData.extInfo.redirectUrl
            }
        }
    })
  }
}
</script>
<style lang="scss">
.detail{
  margin: 20px;
  .detail_img{
      display: flex;
      img{
        display: inline-block;
        margin: 0 auto;
      }
  }
  .detail_name{
      text-align: center;
      font-weight: bolder;
      font-size: 18px;
  }
  .detail_content{
      text-align: center;
  }
  .line{
      &::after{
          content: '';
          position: relative;
          display: block;
          width: 100%;
          height: 1px;
          background-color: #000;
      }
  }
  .detail_price{
      text-align: center;
      font-weight: bolder;
      font-size: 20px;
  }
  .detail_type_tips{
      text-align: center;
      font-size: 12px;
  }
  .van-button{
      height: 38px;
      margin-top: 10px;
      font-size: 14px;
  }
}
</style>